import { CreatorModerationStatusEnum } from "./creators.dto";
import { PayoutStatusEnum } from "./payouts.dto";
import { ApplicationStatusEnum } from "./briefs.dto";
import { HttpRequest } from "@angular/common/http";


export interface FiltersModel {
    ageOptions?: { min: number, max: number };
    date_range?: IDateRange;
    interests?: FilterItemDto[];
    country?: FilterItemDto;
    gender?: FilterItemDto;
    /** Absolute follower counts at discrete steps (0, 1K, 3K, … 10M). Null = no filter. */
    tiktokFollowersRange?: { min: number; max: number } | null;
    instagramFollowersRange?: { min: number; max: number } | null;
    youtubeSubscribersRange?: { min: number; max: number } | null;
    snapchatFollowersRange?: { min: number; max: number } | null;
    /** Discrete size option (used by legacy magic-filters UI). */
    tiktokSize?: FilterItemDto;
    instagramSize?: FilterItemDto;
    youtubeSize?: FilterItemDto;
    snapchatSize?: FilterItemDto;
    sort?: FilterItemDto;
    platform?: FilterItemDto[];
    isVerified?: FilterItemDto;
    searchTerm?: string;
    brand?: FilterItemDto;
    briefs?: FilterItemDto;
    homeTownSearchTerm?: string;
    requestMethod?: FilterItemDto;
    recruitGroup?: FilterItemDto;
}

export interface FilterBriefsDto {
    briefId?: string;
    campaignId?: string;
    statuses?: number[];
    take?: number;
    skip?: number;
}
export interface ActiveFiltersModel {
    ageOptions?: { min?: number, max?: number };
    dateOptions?: { from?: string, to?: string };
    interestsOptions?: FilterItemDto[];
    countryOptions?: FilterItemDto[];
    genderOptions?: FilterItemDto[];
    tiktokSizeOptions?: FilterItemDto[];
    instagramSizeOptions?: FilterItemDto[];
    youtubeSizeOptions?: FilterItemDto[];
    snapchatSizeOptions?: FilterItemDto[];
    sortOptions?: FilterItemDto[];
    platformOptions?: FilterItemDto[];
    isVerifiedOptions?: FilterItemDto[];
    moderationStatus?: CreatorModerationStatusEnum | number;
    payoutStatus?: PayoutStatusEnum;
    currencyCodeOptions?: FilterItemDto[];
    brandOptions?: FilterItemDto[];
    briefsOptions?: FilterItemDto[];
    homeTownSearchTerm?: string;
    errorStatusOptions?: FilterItemDto[];
    requestMethodOptions?: FilterItemDto[];
}

export interface FilterItemDto {
    id: number | string;
    name: string;
    value?: any;
    icon?: IIcon;
    type?: string;
    class?: string;
    description?: string;
    direction?: 'ASC' | 'DESC';
    image?: string;
    active?: boolean;
}

export interface IIcon {
    name: string;
    type: 'fas' | 'far' | 'fab';
    fill?: string;
    stroke?: string;
    strokeWidth?: string;
    size?: number;
    class?: string;
}

export interface FilterCreatorsDto {
    ageFrom?: Date | number;
    ageTo?: Date | number;
    applicationStatus?: ApplicationStatusEnum[];
    brand?: string[];
    briefs?: string[];
    businessAccountId?: string;
    country?: string[];
    country_code?: string;
    ethnicGroup?: number[];
    gender?: number[] | number | string;
    hasHandle?: boolean;
    hasPortfolio?: boolean;
    hasProfilePic?: boolean;
    hasReviews?: boolean;
    homeTownSearchTerm?: string;
    instagramFollowersFrom?: number | null;
    instagramFollowersTo?: number | null;
    interests?: number[];
    isVerified?: boolean;
    limitModerationStatus?: number[] | null;
    location?: string[];
    ltRating?: number;
    moderationStatus?: number | null;
    /** Assignment tab: only creators waiting on the brand. */
    needsYou?: boolean;
    rating?: number;
    searchTerm?: string;
    skip?: number;
    snapchatFollowersFrom?: number | null;
    snapchatFollowersTo?: number | null;
    socialChannel?: number;
    sortField?: string;
    sortOrder?: string;
    take?: number;
    tikTokFollowersFrom?: number | null;
    tikTokFollowersTo?: number | null;
    youtubeSubscribersFrom?: number | null;
    youtubeSubscribersTo?: number | null;
    tikTokAverageEngagementFrom?: number | null;
    tikTokAverageViewsFrom?: number | null;
    tikTokAverageViewsTo?: number | null;
    tikTokTotalViewsFrom?: number | null;
    tikTokTotalViewsTo?: number | null;
    tikTokAverageLikesFrom?: number | null;
    tikTokAverageLikesTo?: number | null;
    tikTokTotalLikesFrom?: number | null;
    tikTokTotalLikesTo?: number | null;
    instagramAverageEngagementFrom?: number | null;
    instagramAverageViewsFrom?: number | null;
    instagramAverageViewsTo?: number | null;
    instagramTotalViewsFrom?: number | null;
    instagramTotalViewsTo?: number | null;
    instagramAverageLikesFrom?: number | null;
    instagramAverageLikesTo?: number | null;
    instagramTotalLikesFrom?: number | null;
    instagramTotalLikesTo?: number | null;
    youtubeAverageEngagementFrom?: number | null;
    youtubeAverageViewsFrom?: number | null;
    youtubeAverageViewsTo?: number | null;
    youtubeTotalViewsFrom?: number | null;
    youtubeTotalViewsTo?: number | null;
    youtubeAverageLikesFrom?: number | null;
    youtubeAverageLikesTo?: number | null;
    youtubeTotalLikesFrom?: number | null;
    youtubeTotalLikesTo?: number | null;
    briefId?: string;
    recruitGroup?: string[];
    exclusive_to_business_id?: string | null;
    [key: string]: any;
}

export interface ApplicantsFilter extends FilterCreatorsDto {
    applicationStatus?: ApplicationStatusEnum[]
}

export interface FilterErrorLogsDto {
    browser?: string;
    created_date?: Date;
    date_range?: IDateRange;
    device?: string;
    error_class?: string;
    error_message?: string;
    error_timestamp?: Date;
    error_url?: string;
    full_request?: HttpRequest<any>,
    id?: string;
    method?: string;
    os?: string;
    request_url?: string;
    skip?: number;
    searchTerm?: string;
    sortField?: string;
    sortOrder?: string;
    status_code?: number;
    take?: number;
    user_email?: string;
    user_id?: string;
    user_name?: string;
    requestMethod?: number;
    [key: string]: any;
}

export interface IDateRange {
    from: string;
    to: string;
}

export interface FilterStatsDto {
    'All': number;
    'Applied': number;
    'Invited': number;
    'Hired': number;
    'ReadyToPost': number;
    'Started': number;
    'Posted': number;
    'Paid': number;
    'Completed': number;
}

export interface BriefApplicationFilterButton {
    applicationStatus: ApplicationStatusEnum;
    btnText: string;
    filterStats: number;
}

export const declineReasons: FilterItemDto[] = [
    {id: 1, name: 'Wrong demographic', icon: {name: 'person_remove', type: 'fas'}, class: 'bg-red-400 hover:bg-red-500 text-white'},
    {id: 2, name: 'Incomplete profile', icon: {name: 'document_incomplete', fill: '#1F2937', class: 'text-gray-800', type: 'fas'}, class: 'bg-red-400 hover:bg-red-500 text-white'},
    {id: 3, name: 'Private account', icon: {name: 'padlock', type: 'fas'}, class: 'bg-red-400 hover:bg-red-500 text-white'},
    {id: 4, name: 'Not enough followers', icon: {name: 'trending_down', type: 'fas'}, class: 'bg-red-400 hover:bg-red-500 text-white'},
    {id: 5, name: 'Meme/fan page', icon: {name: 'theatre_masks', fill: '#1F2937', class: 'text-gray-800', type: 'fas'}, class: 'bg-red-400 hover:bg-red-500 text-white'},
    {id: 6, name: 'Incorrect handle', icon: {name: 'warning', type: 'fas'}, class: 'bg-red-400 hover:bg-red-500 text-white'},
    {id: 7, name: 'Sorry, you haven`t been selected', icon: {name: 'cancel_circle', type: 'fas'}, class: 'bg-red-400 hover:bg-red-500 text-white'},
    {id: 8, name: 'Other', icon: {name: 'question_circle', type: 'fas'}, class: 'bg-red-400 hover:bg-red-500 text-white'},
  ];
  
  
  export const unHireReasons: FilterItemDto[] = [
    {id: 1, name: 'Unresponsive Creator', icon: {name: 'question_circle', type: 'fas'}, class: 'bg-red-400 hover:bg-red-500 text-white'},
    {id: 2, name: 'Not completed in time', icon: {name: 'close', type: 'fas'}, class: 'bg-red-400 hover:bg-red-500 text-white'},
    {id: 3, name: 'Creator requested removal', icon: {name: 'person_remove', type: 'fas'}, class: 'bg-red-400 hover:bg-red-500 text-white'},
    {id: 4, name: 'Campaign was over-hired', icon: {name: 'people', type: 'fas'}, class: 'bg-red-400 hover:bg-red-500 text-white'},
    {id: 8, name: 'Other', icon: {name: 'question_circle', type: 'fas'}, class: 'bg-red-400 hover:bg-red-500 text-white'},
  ];
